
import { Action } from "../../../actions/application/domain/actions";
import { SessionExecutionContainer, ActionDescription, ButtonContainer, ButtonOk, ButtonFail, FinishSessionContainer } from "./style"

export interface SessionControlProps {
    currentAction: Action | null;
}

export const SessionControl = ({ currentAction }: SessionControlProps) => {

    return (
        <SessionExecutionContainer>
            <ActionDescription key={currentAction?.id ?? currentAction?.description ?? "empty"}>
                {currentAction?.description}
            </ActionDescription>

            {/* <ButtonContainer>
                <ButtonOk>CERTO</ButtonOk>
                <ButtonFail>ERRADO</ButtonFail>
            </ButtonContainer> */}

        </SessionExecutionContainer>
    )
}